import React, { useEffect, useState } from 'react';
import { styles } from './Style';
import Line from '../../../assets/svg/Line';
import { featureDescriptions, formatPrice, getEnabledFeatures } from '../../../utlites';
import { FiCheck } from 'react-icons/fi';
import EmptyPlans from '../../../assets/svg/Empty';
import LogoCredit from '../../../assets/svg/CreditLogo';


export default function ThirdStep({ formik, submitLoading,setPlanId=()=>{},setBillingCycleText=()=>{},nextStep=()=>{} }) {
    const [billingCycle, setBillingCycle] = useState('monthly');
    const [selectedPlan, setSelectedPlan] = useState(formik.values.selectedPlan || null);
    const [loading, setLoading] = useState(false);
    const [pricingPlans, setPricingPlans] = useState([])
    const [loadingPlanId, setLoadingPlanId] = useState(null);

    const handlePlanSelect = (plan) => {
        setSelectedPlan(plan.id);
        setPlanId(plan.id);
        setLoadingPlanId(plan.id);
        setBillingCycleText(billingCycle);
        formik.setFieldValue('selectedPlan', plan.id);
        nextStep(prev => prev + 1);
    };


    const getAllPlans = async () => {
        try {
            setLoading(true);
            const res = await fetch(`${process.env.REACT_APP_BASE_URL}/subscribe_company/enabled`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "appname": "LimeTi",
                }
            });
            const data = await res.json();
            console.log("plan && Price : ", data);
            if (data.success === true && Array.isArray(data?.data)) {
                setPricingPlans(data.data);
            }
        } catch (error) {
            console.log(error);
            setPricingPlans([]);
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getAllPlans();
    }, []);

    if (loading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
                <div className="spinner-border" role="status">
                    <span className="sr-only"></span>
                </div>
            </div>
        )
    }

    return (
        <div style={styles.container}>

            {/* Error  */}
            {
                !selectedPlan && formik.errors.selectedPlan && (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <span style={{ ...styles.badgeText, color: "red" }}>Plan is required please click in the plan</span>
                    </div>
                )
            }

            {/* No Credit Card Badge */}
            <div style={styles.badge}>
                <div style={styles.noCreait}>
                    <LogoCredit/>
                    <span style={styles.badgeText}>No credit card required</span>
                </div>
            </div>

            
            {/* Pricing Cards - Horizontal Scroll */}
            {
                Array.isArray(pricingPlans) && pricingPlans?.length > 0 ? 
                    (
                        <div style={styles.scrollContainer}>
                            <div style={{...styles.pricingGrid}}>
                                {pricingPlans.map((plan) => {
                                    const isPopularOrSelected = plan?.is_recommended;

                                    return (
                                        <div
                                            key={plan.id}
                                            style={{
                                                ...styles.card,
                                                zIndex: 1,
                                                backgroundColor: plan?.is_recommended ? '#7bb321' : "#fff"
                                            }}
                                        >
                                            {plan.is_recommended && (
                                                <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", marginBottom:"2px" }}>
                                                    <div style={styles.popularBadge}>MOST POPULAR</div>
                                                </div>
                                            )}

                                            <div style={styles.cardContent}>
                                                {/* Price */}
                                                <div style={styles.priceSection}>
                                                    <div>
                                                        <span style={{
                                                            ...styles.price,
                                                            color: isPopularOrSelected ? '#fff' : '#1a1a1a'
                                                        }}>
                                                            {formatPrice(plan.price_monthly)}
                                                        </span>
                                                        <span style={{
                                                            ...styles.period,
                                                            color: isPopularOrSelected ? '#fff' : '#666'
                                                        }}>
                                                            /Monthly
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span style={{
                                                            ...styles.price,
                                                            color: isPopularOrSelected ? '#fff' : '#1a1a1a'
                                                        }}>
                                                            {formatPrice(plan.price_yearly)}
                                                        </span>
                                                        <span style={{
                                                            ...styles.period,
                                                            color: isPopularOrSelected ? '#fff' : '#666'
                                                        }}>
                                                            /Yearly
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Employees */}
                                                <p style={{
                                                    ...styles.employees,
                                                    color: isPopularOrSelected ? '#fff' : '#666'
                                                }}>
                                                    Up to {plan.employee_limit} employees
                                                </p>

                                                {/* free_trial_days */}
                                                <p style={{
                                                    ...styles.employees,
                                                    color: isPopularOrSelected ? '#fff' : '#666'
                                                }}>
                                                    {plan.free_trial_days} Free Days
                                                </p>

                                                {/* Plan Name */}
                                                <h3 style={{
                                                    ...styles.planName,
                                                    color: isPopularOrSelected ? '#fff' : '#1a1a1a'
                                                }}>
                                                    {plan.name}
                                                </h3>

                                                {/* Description */}
                                                <p style={{
                                                    ...styles.description,
                                                    color: isPopularOrSelected ? '#fff' : '#666'
                                                }}>
                                                    {plan.description}
                                                </p>

                                                {/* Features plan?.features?.permission || {}*/}
                                                <div style={styles.featuresContainer}>
                                                    {Array.isArray(getEnabledFeatures(plan?.features?.permission || {})) && getEnabledFeatures(plan?.features?.permission || {}).length > 0 && (
                                                        getEnabledFeatures(plan?.features?.permission || {}).map((feature, index) => (
                                                            <div key={index} style={styles.featureItem}>
                                                                <div style={{
                                                                    ...styles.checkIcon,
                                                                    backgroundColor: isPopularOrSelected ? '#ffffff30' : '#D1FAE5'
                                                                }}>
                                                                    <FiCheck
                                                                        size={14}
                                                                        color={isPopularOrSelected ? '#fff' : '#10B981'}
                                                                    />
                                                                </div>
                                                                <p style={{
                                                                    ...styles.featureText,
                                                                    color: isPopularOrSelected ? '#fff' : '#374151'
                                                                }}>
                                                                    {featureDescriptions[feature]}
                                                                </p>
                                                            </div>
                                                        ))
                                                    )}
                                                </div>

                                                {/* Button */}
                                                <button
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handlePlanSelect(plan);
                                                    }}
                                                    disabled={submitLoading && loadingPlanId !== plan.id}
                                                    style={{
                                                        ...styles.planButton,
                                                        backgroundColor: isPopularOrSelected ? '#fff' : '#7bb321',
                                                        color: isPopularOrSelected ? '#7bb321' : '#fff'
                                                    }}
                                                >
                                                    {
                                                        submitLoading && loadingPlanId === plan.id ?
                                                            <div style={{ display: "flex", justifyContent: "center", }}>
                                                                <div class="spinner-border" role="status">
                                                                    <span class="sr-only"></span>
                                                                </div>
                                                            </div>
                                                        : 
                                                            "Start Free Trail"
                                                    }
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )
                :
                    (
                        <div style={{width: "100%" , display: "flex", flexDirection: "column", justifyContent: "center",alignItems: "center",gap: "5px"}}>
                            <EmptyPlans />
                            <div style={{display: "flex" , flexDirection: "column" , alignContent: "center", justifyContent: "center", gap: "5px"}}>
                                <p style={{color: "#101828", fontSize: "36px", fontWeight: "700", textAlign: "center",marginBottom: "0px"}}>
                                    No Active Plans found
                                </p>
                                <p style={{color: "#4A5565" , textAlign: "center", fontSize: "16px", fontWeight: "400", marginBottom: "0px", margin: "auto" , width: "50%"}}>
                                    This company hasn’t added any subscription plans yet. Please check back later or contact the company administrator for more information
                                </p>
                            </div>
                        </div>
                    )
            }

            {/* Decorative Dots */}
            <div style={{ ...styles.dot, top: '1%', left: '5%', backgroundColor: '#ff6b6b' }} />
            <div style={{ ...styles.dot, top: '1%', right: '8%', backgroundColor: '#7bb321' }} />
            <div className="position-absolute" style={{ right: "90px", top: "-160px" }}>
                <Line />
            </div>
        </div>
    );
}